var map = {
	"./andoird.svg": 7651,
	"./apple.svg": 1548,
	"./arrow_left.svg": 5442,
	"./arrow_right.svg": 690,
	"./download_blue.svg": 2067,
	"./download_white.svg": 1645,
	"./function_1.svg": 9344,
	"./function_2.svg": 7641,
	"./function_3.svg": 4127,
	"./icon_address.svg": 8364,
	"./icon_close.svg": 4691,
	"./icon_mail.svg": 2325,
	"./icon_mob.svg": 7004,
	"./icon_tel.svg": 3733,
	"./lang_en.svg": 3490,
	"./lang_zh.svg": 6870,
	"./menu.svg": 5674,
	"./play.svg": 5590,
	"./product.svg": 234,
	"./scroll_to_top.svg": 4699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;